import { render, staticRenderFns } from "./couponModal.vue?vue&type=template&id=6c0cca15&scoped=true&"
import script from "./couponModal.vue?vue&type=script&lang=js&"
export * from "./couponModal.vue?vue&type=script&lang=js&"
import style0 from "./couponModal.vue?vue&type=style&index=0&id=6c0cca15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0cca15",
  null
  
)

export default component.exports